import { createAction } from '@reduxjs/toolkit';

export const tiktokUpdateId = createAction('tiktok/updateId');
export const tiktokUpdateIsAdded = createAction('tiktok/updateIsAdded');
export const tiktokUpdateIsActive = createAction('tiktok/updateIsActive');

export const tiktokStore = createAction('tiktok/store');
export const tiktokClear = createAction('tiktok/clear');

export const tiktokUpdateRequest = createAction('tiktok/updateRequest');
export const tiktokUpdateError = createAction('tiktok/updateError');
export const tiktokUpdateStore = createAction('tiktok/updateStore');

export const tiktokUpdateItems = createAction('tiktok/updateItems');
export const tiktokUpdateUser = createAction('tiktok/updateUser');

export const tiktokUpdatePostLayout = createAction('tiktok/updatePostLayout');
export const tiktokUpdateLayout = createAction('tiktok/updateLayout');
export const tiktokUpdateView = createAction('tiktok/updateView');

export const tiktokUpdateHeadingTitle = createAction('tiktok/updateHeadingTitle');
export const tiktokUpdateHeadingDescription = createAction('tiktok/updateHeadingDescription');
export const tiktokUpdateHeadingTextAlign = createAction('tiktok/updateHeadingTextAlign');
export const tiktokUpdateHeadingImage = createAction('tiktok/updateHeadingImage');
export const tiktokUpdateHeadingDivider = createAction('tiktok/updateHeadingDivider');

export const tiktokUpdateSectionIsBackground = createAction('tiktok/updateSectionIsBackground');
export const tiktokUpdateSectionTextColor = createAction('tiktok/updateSectionTextColor');
export const tiktokUpdateSectionBackgroundColor = createAction('tiktok/updateSectionBackgroundColor');
export const tiktokUpdateSectionOpacity = createAction('tiktok/updateSectionOpacity');
export const tiktokUpdateSectionIsFullWidth = createAction('tiktok/updateSectionIsFullWidth');
export const tiktokUpdateSectionShadow = createAction('tiktok/updateSectionShadow');
export const tiktokUpdateSectionShadowColor = createAction('tiktok/updateSectionShadowColor');
export const tiktokUpdateSectionPadding = createAction('tiktok/updateSectionPadding');
export const tiktokUpdateSectionMargin = createAction('tiktok/updateSectionMargin');
export const tiktokUpdateSectionBackgroundType = createAction('tiktok/updateSectionBackgroundType');
export const tiktokUpdateSectionBackgroundImage = createAction('tiktok/updateSectionBackgroundImage');
export const tiktokUpdateSectionGradientColor1 = createAction('tiktok/updateSectionGradientColor1');
export const tiktokUpdateSectionGradientColor2 = createAction('tiktok/updateSectionGradientColor2');
export const tiktokUpdateSectionGradientDirection = createAction('tiktok/updateSectionGradientDirection');
export const tiktokUpdateSectionGradientOffset = createAction('tiktok/updateSectionGradientOffset');
export const tiktokUpdateSectionBorder = createAction('tiktok/updateSectionBorder');
export const tiktokUpdateSectionBorderColor = createAction('tiktok/updateSectionBorderColor');
export const tiktokUpdateSectionShadowBorderColor = createAction('tiktok/updateSectionShadowBorderColor');
export const tiktokUpdateSectionShape = createAction('tiktok/updateSectionShape');
